import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableSortLabel,
  Typography,
} from "@material-ui/core";
import { FC, useState } from "react";
import { useStyles } from "./styles";
import TrackerHead from "./TrackerHead";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { TrackerRow } from "./TrackerRow";
import { TABLE_SIDE_ROWS } from "./trackerTable";
import Loader from "router/components/Loader";
import { TrackerData } from "types/Tracker";

interface PropsType {}

const TrackerTableSortLabel = ({
  rowId,
  rowLabel,
  order,
  orderBy,
  hasSortLabel,
  handleRequestSort,
}: any) => {
  const classes = useStyles();
  return (
    <TableSortLabel
      disabled={!hasSortLabel}
      active={orderBy === rowId}
      direction={orderBy === rowId ? order : "asc"}
      onClick={() => handleRequestSort(rowId)}
      className={classes.labelwithArrow}
    >
      <Typography className={classes.fontWeight}>{rowLabel}</Typography>
    </TableSortLabel>
  );
};

const TrackerPage: FC<PropsType> = () => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState("");
  const { dataList, loadingData } = useTypeSelectors((state) => state.trackerTable);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<any>("created");

  const handleRequestSort = (column_id: string | undefined) => {
    const isAsc = orderBy === column_id && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column_id);
  };

  return (
    <Box className={classes.root}>
      <Loader isLoading={loadingData} />
      <Paper className={classes.paper}>
        <TrackerHead searchValue={searchValue} onSearchValueChange={setSearchValue} />
      </Paper>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            {TABLE_SIDE_ROWS?.map((row: any) => (
              <TableCell key={row.id} className={classes.tableCell}>
                <TrackerTableSortLabel
                  rowId={row.id}
                  rowLabel={row.label}
                  order={order}
                  orderBy={orderBy}
                  hasSortLabel={row?.hasSortLabel}
                  handleRequestSort={handleRequestSort}
                />
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {dataList
              ?.sort(getComparator(order, orderBy))
              ?.filter(
                (row) =>
                  row?.name?.toLocaleLowerCase()?.includes(searchValue.toLocaleLowerCase()) ||
                  row?.transporter_id
                    ?.toLocaleLowerCase()
                    ?.includes(searchValue.toLocaleLowerCase()),
              )
              ?.map((row: TrackerData) => <TrackerRow tableRow={row} />)}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

function descendingComparator<T>(a: any, b: any, orderBy: keyof T) {
  if (a[orderBy] === null) return 1;
  if (b[orderBy] === null) return -1;
  if (b[orderBy] < a[orderBy] || b[orderBy]?.name < a[orderBy]?.name) {
    return -1;
  }
  if (b[orderBy] > a[orderBy] || b[orderBy]?.name > a[orderBy]?.name) {
    return 1;
  }
  return 0;
}

function getComparator(
  order: "asc" | "desc",
  orderBy: keyof TrackerData,
): (a: TrackerData, b: TrackerData) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default TrackerPage;
